export default "__VITE_ASSET__Wa2kt1gi__"